import { getLink } from "../../../../utils/utils";

import translator from "../translator";

const content = {
	esp: (
		`
		<p class="mb-3">
			La Herbero ekamis la Sunon…
		</p>
		
		<p class="mb-3">
			Klare, ke ŝi eĉ ne pretendis la respondon: ja la Suno vidas tiom da aĴoj sur la Tero; ĉu povas li rimarki la modestan Herberon? Kai imagu, kia ridinda paro aperus: la Herbero – kaj la Suno!
		</p>
		
		<p class="mb-3">
			Sed la Herbero imagis, ke la paro estus tute deca, kaj ŝi sin trenis al la Suno per ĉiuj siaj fortoj. Kaj fine ŝi fariĝis alta, svelta Palmo. Bela Palmo, mirinda Palmo – kiu ekkonus en ŝi la iaman malimponan Herberon?
		</p>
		
		<p class="mb-3">
			Jen kion faras el ni la Amo, eĉ se nericeproka…
		</p>
		`
	)
}

const itemName = {
	esp: 'La amo'
}

const item = {
	itemlink: getLink(itemName.esp),
	esp: {
		itemName: itemName.esp,
		itemContent: content.esp,
		itemTranslator: translator.esp
	}
}

export default item;